import { render, staticRenderFns } from "./PagingEcgChartView.vue?vue&type=template&id=c88ab014&scoped=true&"
import script from "./PagingEcgChartView.vue?vue&type=script&lang=js&"
export * from "./PagingEcgChartView.vue?vue&type=script&lang=js&"
import style0 from "./PagingEcgChartView.vue?vue&type=style&index=0&id=c88ab014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88ab014",
  null
  
)

export default component.exports